import { render, staticRenderFns } from "./Agile.vue?vue&type=template&id=5f966ea0"
import script from "./Agile.vue?vue&type=script&lang=js"
export * from "./Agile.vue?vue&type=script&lang=js"
import style0 from "./Agile.vue?vue&type=style&index=0&id=5f966ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports